import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {digg} from "diggerize"
import memo from "set-state-compare/build/memo"
import Services from "@kaspernj/api-maker/build/services"
import {Text} from "shared/base"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import UtilsCard from "components/utils/card"
import {View} from "react-native"

/** @typedef {object} RoutesAdminRoutesOverviewRouteProps */

/**
 * @typedef {object} RoutesAdminRoutesOverviewRouteState
 * @property {unknown} routes
 */

/**
 * @extends {ShapeComponent<RoutesAdminRoutesOverviewRouteProps, RoutesAdminRoutesOverviewRouteState>}
 */
class RoutesAdminRoutesOverviewRoute extends ShapeComponent {
  /** @type {RoutesAdminRoutesOverviewRouteState} */
  state = {
    routes: null
  }

  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.routes_overview.routes_overview"})

    useAdminLayout()?.setState({active: "routes-overview", headerTitle: t(".routes_overview")})


    useMemo(() => {
      this.loadRoutes()
    }, [])
  }

  async loadRoutes() {
    const result = await Services.current().sendRequest("RoutesOverview")

    this.setState({routes: digg(result, "routes")})
  }

  render() {
    return (
      <View dataSet={{route: "admin/routes-overview"}}>
        <UtilsCard>
          {this.s.routes?.map((route) =>
            <Text dataSet={{class: "route-item"}} key={route}>
              {route}
            </Text>
          )}
        </UtilsCard>
      </View>
    )
  }
}

export default memo(shapeComponent(RoutesAdminRoutesOverviewRoute))
